import React, { Fragment, useEffect } from 'react';
import { Skeleton, SkeletonNormalList, SkeletonParagraph } from '@hose/eui';
import styles from './Skeleton.module.less';
var delay = 3000;
var SkeletonBase = function (props) {
    var skeletons = new Array(props.length).map(function (v, i) { return (React.createElement(Fragment, { key: i },
        React.createElement(Skeleton, { type: "title", className: "h_m", animated: true }),
        React.createElement(SkeletonParagraph, null))); });
    return React.createElement(React.Fragment, null, skeletons);
};
var SkeletonList = function (props) {
    var _a = props.length, length = _a === void 0 ? 5 : _a, _b = props.showTop, showTop = _b === void 0 ? true : _b, _c = props.style, style = _c === void 0 ? {} : _c, _d = props.isPadding, isPadding = _d === void 0 ? true : _d;
    useEffect(function () {
        var _a;
        var time = (_a = props === null || props === void 0 ? void 0 : props.delay) !== null && _a !== void 0 ? _a : delay;
        setTimeout(function () {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.onSkeleton) === null || _a === void 0 ? void 0 : _a.call(props, false);
        }, time);
    }, []);
    return (React.createElement("div", { className: styles['home-skeleton-warp'], style: isPadding ? {} : { padding: 0 } },
        showTop && (React.createElement(SkeletonNormalList, { showTitle: true, showText: true, showAvatar: true, showAction: true, className: styles['home-skeleton-warp-normal'] })),
        React.createElement("div", { className: styles['home-skeleton-warp-base'], style: style },
            React.createElement(SkeletonBase, { length: length }))));
};
export default SkeletonList;
